import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.327 3.638C0 4.28 0 5.12 0 6.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C2.28 18 3.12 18 4.8 18h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 15.72 20 14.88 20 13.2V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 2 16.88 2 15.2 2H4.8c-1.68 0-2.52 0-3.162.327A3 3 0 00.327 3.638zm5.239 2.537a1 1 0 00-1.132 1.65l3.869 2.654a3 3 0 003.394 0l3.869-2.654a1 1 0 00-1.132-1.65L10.566 8.83a1 1 0 01-1.132 0L5.566 6.175z"
        fill={props.color ?? "#353945"}
      />
    </svg>
  );
}

export default SvgComponent;
